import React, { useState, useMemo, useEffect }  from 'react';
import Modal from 'react-modal';
import { useMsal, useAccount } from "@azure/msal-react";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import TextField from '@mui/material/TextField';
import Datetime from 'react-datetime';
import jQuery from 'jquery';
import { MaterialReactTable } from 'material-react-table';
import accounting from 'accounting';

import { Editor } from 'react-draft-wysiwyg';
import { EditorState, ContentState, convertFromHTML, convertToRaw } from 'draft-js'
import draftToHtml from 'draftjs-to-html';

import * as Utils from '../lib/utils';
import CONFIG from '../config';

import "react-datetime/css/react-datetime.css";
import '../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

const modalStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)'
  },
};

const requestCompensationModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    height:"450px",
    width: "600px"
  },
};

const dateModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    height:"400px",
    width: "600px"
  },
};

const missingRangesModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    height:"700px",
    width: "80%"
  },
};

const mailerHistoryModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    height:"700px",
    width: "1300px",
    overflowY: "hidden"
  },
};

const addExclusionModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    height:"300px",
    width: "700px"
  },
};


window.jQuery = jQuery;
require("jsgrid");

const HR = (props) => {
  const { instance, accounts, inProgress } = useMsal();
  const account = useAccount(accounts[0] || {});

  const [activeUser, setActiveUser] = useState([]);
  const [userData, setUserData] = useState([]);
  const [pendingAdjustmentsData, setPendingAdjustmentsData] = useState({});
  const [reviewAdjustmentsData, setReviewAdjustmentsData] = useState({});
  const [approvedAdjustmentsData, setApprovedAdjustmentsData] = useState({});
  const [closedAdjustmentsData, setClosedAdjustmentsData] = useState({});

  const [selectedAdjustmentDetailsData, setSelectedAdjustmentDetailsData] = useState({});
  
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);    
  const [rowCount, setRowCount] = useState(0);

  const [modalUserIsOpen, setUserIsOpen] = useState(false);
  const [modalUserAction, setModalUserAction] = useState("");
  const [modalUserBody, setModalUserBody] = useState("");
  const [modalSelectedUser, setModalSelectedUser] = useState(null);
  const [modalUserTitle, setModalUserTitle] = useState("");

  const [modalEmail, setModalEmail] = useState("");
  const [modalFirstName, setModalFirstName] = useState("");
  const [modalLastName, setModalLastName] = useState("");
  const [modalAccessLevel, setModalAccessLevel] = useState("");
  const [modalReviewContact, setModalReviewContact] = useState(false);

  const [modalCompensationIsOpen, setCompensationIsOpen] = useState(false);
  const [compensationOpenDate, setCompensationOpenDate] = useState("");
  const [compensationEligibilityDate, setCompensationEligibilityDate] = useState("");
  const [compensationEffectiveDate, setCompensationEffectiveDate] = useState("");
  const [compensationDeadlineDate, setCompensationDeadlineDate] = useState("");
  const [waFlsaThreshold, setWaFlsaThreshold] = useState("");
  
  const [overrideCurrentAdjustments, setOverrideCurrentAdjustments] = useState(false);
  
  const [modalEmployeeListIsOpen, setEmployeeListIsOpen] = useState(false);
  const [adjustmentEmployeeList, setAdjustmentEmployeeList] = useState([]);

  const [modalRequestResultsIsOpen, setRequestResultsIsOpen] = useState(false);
  const [requestResultsStatus, setRequestResultsStatus] = useState("pending");
  const [ineligibleEmployees, setIneligibleEmployees] = useState([]);

  const [modalPreviewIsOpen, setPreviewIsOpen] = useState(false);

  const [modalEmailIsOpen, setEmailIsOpen] = useState(false);
  const [activeAdjustment, setActiveAdjustment] = useState(null);
  const [adjustmentStatus, setAdjustmentStatus] = useState("pending")
  const [adjustmentManagers, setAdjustmentManagers] = useState(null);

  const [modalDateIsOpen, setDateIsOpen] = useState(false);
  const [modalDateValue, setModalDateValue] = useState(null);
  const [modalDateType, setModalDateType] = useState(null);
  const [modalDateAdjustment, setModalDateAdjustment] = useState(null);

  const [modalWaFlsaThresholdIsOpen, setWaFlsaThresholdIsOpen] = useState(false);
  const [modalWaFlsaThresholdValue, setModalWaFlsaThresholdValue] = useState("");
  const [modalWaFlsaThresholdAdjustment, setModalWaFlsaThresholdAdjustment] = useState(null);

  const [missingRangesIsOpen, setMissingRangesIsOpen] = useState(false);  
  const [missingRangesData, setMissingRangesData] = useState(false);  
  const [displayMissingRanges, setDisplayMissingRanges] = useState(false);

  const [showJobRangeSelector, setShowJobRangeSelector] = useState(false);
  const [jobRangesArray, setJobRangesArray] = useState([]);
  const [selectedGroupDetails, setSelectedGroupDetails] = useState([]);
  const [selectedJobRange, setSelectedJobRange] = useState([]);
  const [resolvedSalaryGroup, setResolvedSalaryGroup] = useState("A");

  const [mailerHistoryIsOpen, setMailerHistoryIsOpen] = useState(false);  
  const [mailerHistoryData, setMailerHistoryData] = useState(false);  
  const [displayMailerMessage, setDisplayMailerMessage] = useState(false);  
  const [selectedMailerMessage, setSelectedMailerMessage] = useState(false);  
  const [selectedMailerSubject, setSelectedMailerSubject] = useState(false);  
  
  const [addExclusionIsOpen, setAddExclusionIsOpen] = useState(false);  
  const [selectedAddExclusion, setSelectedAddExclusion] = useState(-1);

  const [emailContents, setEmailContents] = useState("");
  const [emailSubject, setEmailSubject] = useState("Compensation system request from HR");
  const [isSaving, setIsSaving] = useState(false);
  const [editorState, setEditorState] = useState(
    EditorState.createWithContent(
      ContentState.createFromBlockArray(
        convertFromHTML(emailContents)
      )
    )
  )
  const [currentEditorValue, setCurrentEditorValue] = useState(draftToHtml(convertToRaw(editorState.getCurrentContent())));

  const [selectedManagers, setSelectedManagers] = useState([])

  const thisYear = (new Date()).getFullYear();

  const employeeHrisId = props && props.userAccount && props.userAccount.employee_hris_id ? props.userAccount.employee_hris_id : -1;
  const employeeId = props && props.userAccount && props.userAccount.id ? props.userAccount.id : -1;

  let subtitle;

  const onEditorStateChange = (editorStateEvent)=> {
    // handleEmailTemplate(editorStateEvent)
    setEditorState(editorStateEvent);
  };


  function openUserModal(action, userInfo) {
    setModalUserAction(action);
    setUserModalText(action, userInfo);
    setUserIsOpen(true);
  }
  function setUserModalText(action, userInfo) {

    let header = "";
    let body = action !== "delete" ? 
      (<div>
        <div>
          <span className="hrUserInputLabel">Email: </span>
          <input name="email" id="email" defaultValue={userInfo ? userInfo.email : ""} onChange={evt => setModalEmail(evt.target.value)} />
          <br />
          <span className="hrUserInputLabel">First Name: </span>
          <input name="firstName" id="firstName" defaultValue={userInfo ? userInfo.first_name : ""} onChange={evt => setModalFirstName(evt.target.value)} />
          <br />
          <span className="hrUserInputLabel">Last Name: </span>
          <input name="lastName" id="lastName" defaultValue={userInfo ? userInfo.last_name : ""} onChange={evt => setModalLastName(evt.target.value)} />
          <br />
          <span className="hrUserInputLabel">Access Level: </span>
          <input name="accessLevel" id="accessLevel" defaultValue={userInfo ? userInfo.access_level : ""} onChange={evt => setModalAccessLevel(evt.target.value)} />
          <br />
          <span className="hrUserInputLabel">Is Review Contact? </span>
          <input type="checkbox" name="isReviewContact" id="isReviewContact" defaultChecked={userInfo ? userInfo.review_contact : false} onChange={(evt) => {
            setModalReviewContact(evt.target.checked);
          }} />
        </div>
      </div>) : 
      ("Delete the following user: " + userInfo.email + "?");

    if(action==="add"){
      header = "Add a user.";
    }else if(action==="edit"){
      header = "Edit user.";
    }else if(action==="delete"){
      header = "Delete user?";
    }

    setModalEmail(userInfo ? userInfo.email : "");
    setModalFirstName(userInfo ? userInfo.first_name : "");
    setModalLastName(userInfo ? userInfo.last_name : "");
    setModalAccessLevel(userInfo ? userInfo.access_level : "");
    setModalReviewContact(userInfo ? userInfo.review_contact : false);

    setModalSelectedUser(userInfo);
    setModalUserTitle(header);
    setModalUserBody(body);
  }
  function afterOpenUserModal() {
    // references are now sync'd and can be accessed.
    // subtitle.style.color = '#f00';
  }
  function closeUserModal() {
    setUserIsOpen(false);
  }

  

  function openEmployeeListModal() {
    setEmployeeListIsOpen(true);
  }
  function afterOpenEmployeeListModal() {
    // references are now sync'd and can be accessed.
    // subtitle.style.color = '#f00';
  }
  function closeEmployeeListModal() {
    setEmployeeListIsOpen(false);
  }



  function openCompensationModal() {
    setCompensationIsOpen(true);
  }
  function afterOpenCompensationModal() {
    // references are now sync'd and can be accessed.
    // subtitle.style.color = '#f00';
  }
  function closeCompensationModal() {
    setCompensationIsOpen(false);
  }


  function openRequestResultsModal() {
    setRequestResultsIsOpen(true);
  }
  function afterOpenRequestResultsModal() {
    return false;
  }
  function closeRequestResultsModal() {
    setRequestResultsIsOpen(false);
  }


  function openPreviewModal(adjustmentItem, managersList, status) {
    setPreviewIsOpen(true);
  }
  function afterOpenPreviewModal() {
    return false;
  }
  function closePreviewModal() {
    setPreviewIsOpen(false);
  }

  function saveEmailTemplate(){
    const newEmailContents = draftToHtml(convertToRaw(editorState.getCurrentContent()));

    Utils.putData(
      ("/api/email_template/" + adjustmentStatus), 
      {
        body : newEmailContents,
        subject : emailSubject
      },
      instance,
      account
    ).then((data) => {
      alert("Template settings saved.")
    }).catch(()=>{
      alert("There was an error saving the template.  If you continue to encounter errors, please reach out to \"softwareengineeringsupport@geoengineers.com\"");
    });
    
    return false;
  }


  function openEmailModal(adjustmentItem, managersList, status, selectedTemplateObject) {
    const days = ["Sunday", "Monday", "Tuesday", "Wednesday","Thursday", "Friday","Saturday"]
    const date = new Date(adjustmentItem.effective_date);
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'long' });
    const year = date.getFullYear();
    const dayOfWeek = date.getDay();
    const cleanDate = days[dayOfWeek] + ", " + month + " " + day + ", " + year;

    let thisEmail = selectedTemplateObject.body;

    //Saturday September 30th, 2023u
    thisEmail = thisEmail.replace("#EFFECTIVEDATE#", cleanDate);
    setEmailSubject(selectedTemplateObject.subject);
    setEmailContents(thisEmail);
    setCurrentEditorValue(selectedTemplateObject.body);
    setEditorState(
      EditorState.createWithContent(
        ContentState.createFromBlockArray(
          convertFromHTML(thisEmail)
        )
      )
    )    
    setAdjustmentStatus(status);
    setActiveAdjustment(adjustmentItem);
    setAdjustmentManagers(managersList);
    setEmailIsOpen(true);
  }
  function afterOpenEmailModal() {
    return false;
  }
  function closeEmailModal() {
    //end change change check
    setEmailIsOpen(false);
  }


  function openDateModal(adjustmentItem, dateType, status) {
    let dateValue = null;
    if(dateType === "Deadline"){
      dateValue = adjustmentItem.deadline_date;
    }
    if(dateType === "Effective"){
      dateValue = adjustmentItem.effective_date;      
    }
    if(dateType === "Open"){
      dateValue = adjustmentItem.open_date;      
    }
    if(dateType === "Eligibility"){
      dateValue = adjustmentItem.eligibility_date;      
    }
    
    setModalDateType(dateType);
    setModalDateValue(dateValue);
    setModalDateAdjustment(adjustmentItem);
    setDateIsOpen(true);
  }
  function afterOpenDateModal() {
    return false;
  }
  function closeDateModal() {
    setDateIsOpen(false);
  }

  function openWaFlsaThresholdModal(adjustmentItem) {
    setModalWaFlsaThresholdValue(adjustmentItem.wa_flsa_threshold !== null && adjustmentItem.wa_flsa_threshold !== undefined ? adjustmentItem.wa_flsa_threshold.toString() : "");
    setModalWaFlsaThresholdAdjustment(adjustmentItem);
    setWaFlsaThresholdIsOpen(true);
  }
  function closeWaFlsaThresholdModal() {
    setWaFlsaThresholdIsOpen(false);
  }

  
  async function openMissingRangesModal() {
    const missingRanges = await getMissingSalaryRanges();
    setMissingRangesData(missingRanges);
    setMissingRangesIsOpen(true);
  }
  function afterOpenMissingRangesModal() {
    return false;
  }
  function closeMissingRangesModal() {
    setDisplayMissingRanges(false);
    setMissingRangesIsOpen(false);
    setShowJobRangeSelector(false);
    fetchData();
  }


  function openMailerHistoryModal(adjustmentItem, dateType, status) {
    Utils.getData(
      ('/api/email_history'), 
      instance, 
      account
    ).then((results)=>{
      setMailerHistoryData(results);
    });

    setMailerHistoryIsOpen(true);
  }
  function afterOpenMailerHistoryModal() {
    return false;
  }
  function closeMailerHistoryModal() {
    setDisplayMailerMessage(false);
    setMailerHistoryIsOpen(false);
  }


  
  function openAddExclusionModal() {
    setAddExclusionIsOpen(true);
  }
  function afterOpenAddExclusionModal() {
    return false;
  }
  function closeAddExclusionModal() {
    setAddExclusionIsOpen(false);
  }

  const getMissingSalaryRanges = async ()=>{
    const missingRanges = await Utils.getData(
      ('/api/employee/profiles/all?missing_ranges=true'), 
      instance, 
      account
    );
    return missingRanges;
  }


  //saves the user to the DB and updates the client view
  function saveSelectedUser(action, user){
    //DO THE ACTION
    let method;
    let data;

    if(action === "add"){
      method="postData";
      data = {
        email: modalEmail,
        first_name: modalFirstName,
        last_name: modalLastName,
        review_contact: modalReviewContact,
        access_level: modalAccessLevel
      };
    }

    if(action === "edit"){
      method="putData";
      data = {
        id: user.id,
        email: modalEmail,
        first_name: modalFirstName,
        last_name: modalLastName,
        review_contact: modalReviewContact,
        access_level: modalAccessLevel
      };
    }

    if(action === "delete"){
      method="deleteData";  
      data = { id: user.id };
    }

    let localUsers = Utils.copy(userData);

    let fetchAction = action === "delete" ? 
      Utils[method]("/api/user/"+user.id, instance, account) : 
      Utils[method]("/api/user", data, instance, account);
    //update the user on the server
    
    fetchAction.then((data) => {
        
        //find the user in the local list, update as needed
        let rowMatched=false;
        for(var i=0;i<localUsers.length;i++){
          if(user && localUsers[i].id===user.id){
            if(action==="edit"){
              localUsers[i] = data;
            }
            if(action==="delete"){
              localUsers.splice(i, 1);
            }
            rowMatched=true;
            break;
          }
        }

        //add a user to the local list
        if(!rowMatched){
          localUsers.push(data)
        }

        setUserData(localUsers);
        fetchData();
        closeUserModal();

    });

    return false;
  }


  const fetchData = async () => {
    if (!userData.length) {
      setIsLoading(true);
    } else {
      setIsRefetching(true);
    }

    try {
      
      const jsonUsersResponse = await Utils.getData(
        ('/api/user?type=hr'), 
        instance, 
        account
      );

      setUserData(jsonUsersResponse);
      let selectedUser = null
      for(var i=0;i<jsonUsersResponse.length;i++){
        if(accounts[0].username === jsonUsersResponse[i].email){
          selectedUser = jsonUsersResponse[i];
        }
      }
      setActiveUser(selectedUser);

      setRowCount(jsonUsersResponse.length);

      const jsonPendingAdjustmentsResponse = await Utils.getData(
        ('/api/pending'), 
        instance, 
        account
      );
      setPendingAdjustmentsData(jsonPendingAdjustmentsResponse);

      const jsonReviewAdjustmentsResponse = await Utils.getData(
        ('/api/review'), 
        instance, 
        account
      );
      setReviewAdjustmentsData(jsonReviewAdjustmentsResponse);

      const jsonApprovedAdjustmentsResponse = await Utils.getData(
        ('/api/approved'), 
        instance, 
        account
      );
      setApprovedAdjustmentsData(jsonApprovedAdjustmentsResponse);

      const jsonClosedAdjustmentsResponse = await Utils.getData(
        ('/api/closed'), 
        instance, 
        account
      );
      setClosedAdjustmentsData(jsonClosedAdjustmentsResponse);

      const missingRanges = await getMissingSalaryRanges();
      setMissingRangesData(missingRanges);

    } catch (error) {
      setIsError(true);
      console.error(error);
      return;
    }

    setIsError(false);
    setIsLoading(false);
    setIsRefetching(false);
  };

  useEffect(() => {
    
    fetchData();

  }, []);
  


  const requestCompensations = () =>{
  
    if(compensationEffectiveDate){
      Utils.postData(
        "/api/employee_adjustment/all", 
        {
          override_current_adjustments: overrideCurrentAdjustments,
          open_date: compensationOpenDate,
          eligibility_date: compensationEligibilityDate,
          effective_date: compensationEffectiveDate,
          deadline_date: compensationDeadlineDate,
          wa_flsa_threshold: waFlsaThreshold ? parseFloat(waFlsaThreshold) : null
        },
        instance, 
        account
      ).then((data) => {
  
        closeCompensationModal();
        fetchData();
        alert(data.message);

      }).catch((error)=>{
        
        console.log("ERROR", error);
        alert("There was an error creating the requested compensation.");
        
      });
    }else{
      alert("Opening compensation requires an effective date to be set.")
    }
  
    return false;
  }    


  const closeAdjustmentByDateAndStatus = (effectiveDate, status) =>{

    Utils.postData(
      "/api/employee_adjustment/close?effective_date=" + effectiveDate + "&status=" + status,
      {},
      instance, 
      account
    ).then((data) => {

      fetchData();

      if(data && data.result && data.result ==="FAILED"){
        alert(data.message);
      }else{
        alert("Adjustment successfully closed");
      }

    });
    
    return false;
  }


  const deleteAdjustmentByDateAndStatus = (effectiveDate, status) =>{
      Utils.deleteData(
        "/api/employee_adjustment?effective_date=" + effectiveDate + "&status=" + status, 
        instance, 
        account
      ).then((data) => {
  
        fetchData();

        if(data && data.result && data.result ==="FAILED"){
          alert(data.message);
        }else{
          alert("Adjustment successfully deleted");
        }

      });
  }

  
  const handleSelectManager = (e, target)=> {
    const options = [...e.target.selectedOptions];
    const values = options.map(option => option.value);
    setSelectedManagers(values);
    return false;
  };


  const emailManagers = () =>{
    const thisManagers = adjustmentManagers.filter((managerItem)=>{
      return selectedManagers.indexOf(managerItem.id.toString()) > -1;
    });
    // console.log("DEV MODE, ONLY USING JSTOPCHICK@GEOENGINEERS.COM FOR TESTING PURPOSES")

    if(thisManagers.length){
      Utils.postData(
        "/api/compensation/email", 
        {
          manager_list :  thisManagers,
          email_body : draftToHtml(convertToRaw(editorState.getCurrentContent())),
          email_subject: emailSubject,
          status: adjustmentStatus,
          effective_date: activeAdjustment.effective_date
        },
        instance, 
        account
      ).then((data) => {
        alert("Managers emailed.");
        closeEmailModal();
      });
  
    }else{
      alert("Please select at least one manager to continue.");
    }

  }
  

  const processIneligibleEmployees = (adjustmentsArray)=>{
    let employeeList = [];

    for(var i=0;i<adjustmentsArray.length;i++){
      //check if there are indeed ineligible employees
      if(
        adjustmentsArray[i]
        && adjustmentsArray[i].adjustment_details
        && adjustmentsArray[i].adjustment_details.ineligible_employees
      ){

      for(var j=0;j<adjustmentsArray[i].adjustment_details.ineligible_employees.length;j++){
        //if the ineligible employee isn't already in the list, add them
          if(!employeeList.find((employeeItem)=>{
            return employeeItem.first_name === adjustmentsArray[i].adjustment_details.ineligible_employees[j].first_name
              && employeeItem.first_name === adjustmentsArray[i].adjustment_details.ineligible_employees[j].last_name
          })){

            //only show employees with a matching status (can be seen in the employee_list_status in this object
            if(
              adjustmentsArray[i].employee_list && adjustmentsArray[i].employee_list.findIndex((employeeItem)=>{
                return employeeItem.employee_hris_id === adjustmentsArray[i].adjustment_details.ineligible_employees[j].employee_hris_id
              }) > -1
            ){
              // console.log("adjustmentsArray[i]", adjustmentsArray[i]);
              let employeeItem = Utils.copy(adjustmentsArray[i].adjustment_details.ineligible_employees[j]);
              employeeItem.adjustment_uuid = adjustmentsArray[i].adjustment_uuid;
              employeeList.push(employeeItem);
            }

          }

        }
      }
    }

    return employeeList;
  }

  const removeExclusion = (employee, event)=>{
    // console.log("removeExclusion", employee, event);

    Utils.postData(
      "/api/employee_adjustment/remove_exclusion", 
      {
        adjustment_uuid : employee.adjustment_uuid,
        employee_hris_id : employee.employee_hris_id
      },
      instance, 
      account
    ).then((data) => {
      
      Utils.getData(
        ('/api/employee_adjustment/details?status=pending&effective_date=' + selectedAdjustmentDetailsData.adjustment_details.effective_date), 
        instance, 
        account
      ).then((jsonAdjustmentLogResponse)=>{
        const processEmployees = processIneligibleEmployees(jsonAdjustmentLogResponse);
        setIneligibleEmployees(processEmployees);

        alert("Exclusion added to compensation and removed from exclusions list.");
      });

    });

    return false;
  }

  const addExclusion = (event)=>{
    // console.log("addExclusion", event, selectedAddExclusion, selectedAdjustmentDetailsData);
    const employeeToAdd = selectedAdjustmentDetailsData.employee_list.find((employeeItem)=>{
      return parseInt(selectedAddExclusion) === parseInt(employeeItem.employee_hris_id);
    });
    // console.log("employeeToAdd", employeeToAdd);

    Utils.postData(
      "/api/employee_adjustment/add_exclusion", 
      {
        adjustment_uuid : selectedAdjustmentDetailsData.adjustment_uuid,
        employee_hris_id : employeeToAdd.employee_hris_id,
        employee_details : employeeToAdd
      },
      instance, 
      account
    ).then((data) => {

      Utils.getData(
        ('/api/employee_adjustment/details?status=pending&effective_date=' + selectedAdjustmentDetailsData.adjustment_details.effective_date), 
        instance, 
        account
      ).then((jsonAdjustmentLogResponse)=>{
        const processEmployees = processIneligibleEmployees(jsonAdjustmentLogResponse);
        setIneligibleEmployees(processEmployees);
        closeAddExclusionModal();
        alert("Exclusion removed from the compensation and added to the exclusions list.");
      });

    });
    return false;
  }

  const handleDisplayRangeSelector = async (rowData, selectedYear)=>{
    // Fetch salary range data from the Excel file (same source as /salaryDisplay)
    const xlsResponse = await Utils.getData(
      '/api/salary_range/xls_ranges?year=' + selectedYear,
      instance, 
      account
    );
    const xlsData = xlsResponse && xlsResponse.data ? xlsResponse.data : [];

    // Fetch job title aliases from the database
    const aliases = await Utils.getData(
      '/api/job_title_alias',
      instance,
      account
    );

    // Determine the employee's salary group (A/B/C) from their salary_range_group record
    // The group_name field on the row data comes from the salary_range_group table via current_salary_group_id
    const groupName = (rowData.group_name || "").toLowerCase();
    let employeeGroup = "A"; // Default to Group A

    if (groupName.includes("b")) {
      employeeGroup = "B";
    } else if (groupName.includes("c")) {
      employeeGroup = "C";
    } else {
      employeeGroup = "A";
    }

    // Column mappings per group:
    // Group A: col_2 (min), col_3 (mid), col_4 (max)
    // Group B: col_8 (min), col_9 (mid), col_10 (max)
    // Group C: col_14 (min), col_15 (mid), col_16 (max)
    const groupColumns = {
      A: { min: "col_2", mid: "col_3", max: "col_4" },
      B: { min: "col_8", mid: "col_9", max: "col_10" },
      C: { min: "col_14", mid: "col_15", max: "col_16" },
    };
    const cols = groupColumns[employeeGroup];

    // Build a deduplicated list of position titles from the Excel file
    const xlsTitlesSet = new Set();
    xlsData.forEach(row => {
      if (row.col_1 && row.col_1.trim()) {
        xlsTitlesSet.add(row.col_1.trim());
      }
    });
    const xlsTitlesList = Array.from(xlsTitlesSet).sort();

    // Build range items using the correct group columns
    const rangesByTitle = {};
    xlsData.forEach(row => {
      const title = row.col_1 ? row.col_1.trim() : "";
      if (title && !rangesByTitle[title]) {
        rangesByTitle[title] = {
          id: title,
          position_title: title,
          minimum: row[cols.min] || 0,
          midpoint: row[cols.mid] || 0,
          maximum: row[cols.max] || 0,
        };
      }
    });
    const rangeOptions = Object.values(rangesByTitle).sort((a, b) => a.position_title.localeCompare(b.position_title));

    // Find the alias for this employee's position title
    const positionTitle = rowData.position_title || "";
    const alias = aliases && aliases.find(a => a.job_title.toLowerCase() === positionTitle.toLowerCase());
    const aliasedTitle = alias ? alias.salary_range_title : positionTitle;

    // Try to auto-suggest the best match
    const engineerRangeTitles = xlsTitlesList.filter(t => t.toLowerCase().includes("engineer"));
    const scientistRangeTitles = xlsTitlesList.filter(t => t.toLowerCase().includes("scientist"));

    // First try exact match with the aliased title
    let suggestedRange = rangeOptions.find(r => r.position_title.toLowerCase() === aliasedTitle.toLowerCase());

    // If no exact match, use the suggest algorithm
    if (!suggestedRange) {
      const suggestedTitle = Utils.suggestTitleAlias(aliasedTitle, engineerRangeTitles, scientistRangeTitles);
      if (suggestedTitle) {
        suggestedRange = rangeOptions.find(r => r.position_title === suggestedTitle);
      }
    }

    // If still no match, try findClosestTitleMatch against all range titles
    if (!suggestedRange) {
      const closestTitle = Utils.findClosestTitleMatch(aliasedTitle.toLowerCase(), xlsTitlesList);
      if (closestTitle) {
        suggestedRange = rangeOptions.find(r => r.position_title === closestTitle);
      }
    }

    setSelectedGroupDetails(rowData);
    setJobRangesArray(rangeOptions);
    setSelectedJobRange(suggestedRange || rangeOptions[0]);
    setResolvedSalaryGroup(employeeGroup);
    setShowJobRangeSelector(true);
    return false;
  }
  
  
  const handleSaveSalaryRange= async (salaryGroupId, values)=>{
    const thisYear = (new Date()).getFullYear();

    const rangeMinimum = accounting.unformat(values.minimum);
    const rangeMidpoint = accounting.unformat(values.midpoint);
    const rangeMaximum = accounting.unformat(values.maximum);

    if(
      !Utils.isNumeric(rangeMinimum) || !Utils.isNumeric(rangeMidpoint) || !Utils.isNumeric(rangeMaximum) ||
      rangeMinimum <= 0  || rangeMidpoint <= 0  || rangeMaximum <= 0
    ){
      alert("Minimum, midpoint, and maximum must all be positive numeric values.");
      return "Validation Failed";
    }

    await Utils.postData(
      `/api/salary_range`, 
      {
        labor_category : '',
        position_category: '',
        position_title: values.position_title,
        minimum: rangeMinimum,
        midpoint: rangeMidpoint,
        maximum: rangeMaximum,
        group_id: salaryGroupId,
        period_start: thisYear + "-01-01", 
        period_end: thisYear + "-12-31"
      }, 
      instance, 
      account)
    .then((responseData) => {
      return false;
    });
  }


  const matchedAccount = userData.find((userObject)=>{
    return userObject.email === accounts[0].username;
  });
  const authorized = accounts && accounts.length && accounts[0].username && matchedAccount && matchedAccount.email === accounts[0].username;
  const sampleUrl = "https://comp-tool.geoengineers.com/compensation?managerHrisId=-1&status=" + (adjustmentStatus==="closed" ? "approved" : adjustmentStatus);


  const missingRangesColumns = [
    {
      accessorKey: 'employee_hris_id',
      header: 'ID',
      enableEditing: false,
      size: 30
    },
    {
      accessorFn: (row) => `${row.first_name} ${row.last_name}`,
      accessorKey: 'full_name',
      header: 'Full Name',
      enableEditing: false,
      size: 50
    },
    {
      accessorKey: 'position_title',
      header: 'Position Title',
      enableEditing: false
    },
    {
      accessorKey: 'group_name',
      header: 'Group Name',
      enableEditing: false,
      size: 50
    },
    {
      accessorKey: 'group_department',
      header: 'Department',
      enableEditing: false,
      size: 30
    },
    {
      accessorKey: 'minimum',
      header: 'Minimum',
      enableEditing: true,
      size: 30
    },
    {
      accessorKey: 'midpoint',
      header: 'Midpoint',
      enableEditing: true,
      size: 30
    },
    {
      accessorKey: 'maximum',
      header: 'Maximum',
      enableEditing: true,
      size: 30
    },
    {
      accessorKey: 'use_existing',
      header: 'Use Existing',
      enableEditing: false,
      Cell: ({ cell, row }) => {
        return <div><a href="#" onClick={(event)=>{
          event.preventDefault();
          const thisYear = (new Date()).getFullYear();
          handleDisplayRangeSelector(row.original, thisYear);
          return false;
        }}>Resolve</a></div>
      },
    },
  ];

  const mailerHistoryColumns = [
    {
      accessorKey: 'view_details',
      header: 'View',
      enableEditing: false,
      Cell: ({ cell, row }) => {
        return <div><a href="#" onClick={(event)=>{
          event.preventDefault();
          setSelectedMailerMessage(row.original.body);
          setSelectedMailerSubject(row.original.subject);
          setDisplayMailerMessage(true);
          return false;
        }}>View Message</a></div>
      },
    },
    {
      accessorFn: (row) => `${(new Date(row.date_sent)).toLocaleString("en-US")}`,
      accessorKey: 'date_sent',
      header: 'Date Sent',
      enableEditing: false
    },     
    {
      accessorKey: 'recipient_email',
      header: 'Recipient',
      enableEditing: false
    },    
    {
      accessorKey: 'subject',
      header: 'Mail Subject',
      enableEditing: false
    },
  ];
  
  // throw "Monkey Wrench"

  return authorized ? (<div>
    <div id="selectJobTitleRange" style={{ display: (showJobRangeSelector===true ? "block" : "none") }}>
      <div className="rangeSelectorHeader">Ranges from salary display (Group {resolvedSalaryGroup} matching -&gt; {selectedGroupDetails.group_name || "Unknown"}) for "{selectedGroupDetails.position_title}"</div>
      <div className="rangeSelectorBody">
        <select value={selectedJobRange.position_title || ""} onChange={(event)=>{
          event.preventDefault();
          const thisJobRange = jobRangesArray.filter((jobRangeItem)=>{
            return jobRangeItem.position_title === event.target.value;
          });
          setSelectedJobRange(thisJobRange[0]);
          return false;
        }}>
        {jobRangesArray.map((jobRangeItem)=>{
          return <option key={jobRangeItem.position_title} value={jobRangeItem.position_title}>{jobRangeItem.position_title}</option>
        })}
        </select>
      </div>
      <div className="rangeSelectorBody">Selected Range: {Utils.moneyMask(selectedJobRange.minimum)} - {Utils.moneyMask(selectedJobRange.midpoint)} - {Utils.moneyMask(selectedJobRange.maximum)}</div>
      <div className="rangeSelectorFooter">
        <button className="btn btn-primary"
          onClick={async (event)=>{
            event.preventDefault();

            await handleSaveSalaryRange(selectedGroupDetails.salary_group_id, {
              position_title: selectedGroupDetails.position_title,
              minimum: selectedJobRange.minimum,
              midpoint: selectedJobRange.midpoint,
              maximum: selectedJobRange.maximum
            });

            window.alert(`"${selectedGroupDetails.position_title}" range saved with data from "${selectedJobRange.position_title}"`);
            fetchData();

            closeMissingRangesModal(false);
            return false;
          }}
        >Apply</button>
        &nbsp;&nbsp;&nbsp;
        <button className="btn btn-primary"
          onClick={(event)=>{
            event.preventDefault();
            setShowJobRangeSelector(false);
            return false;
          }}
        >Cancel</button>
      </div>
    </div>

    <Modal
      isOpen={modalUserIsOpen}
      onAfterOpen={afterOpenUserModal}
      onRequestClose={closeUserModal}
      style={modalStyles}
      contentLabel="User Details"
      ariaHideApp={false} // ignores need for "Modal.setAppElement('#yourAppElement');"
    >
      <h2 className="modalTitle" ref={(_subtitle) => (subtitle = _subtitle)}>
        {modalUserTitle}
      </h2>
      <div className="modalBody">
        {modalUserBody}
      </div>
      <div className="modalFooter">
        <button className="btn btn-primary" onClick={()=>{
          saveSelectedUser(modalUserAction, modalSelectedUser);
        }}>{modalUserAction === "delete" ? "Delete" : "Save"}</button>
        <button className="btn btn-primary" onClick={closeUserModal}>Cancel</button>
      </div>
    </Modal> 

    <Modal
      isOpen={modalEmployeeListIsOpen}
      onAfterOpen={afterOpenEmployeeListModal}
      onRequestClose={closeEmployeeListModal}
      style={modalStyles}
      contentLabel="Adjustment Employees"
      ariaHideApp={false} // ignores need for "Modal.setAppElement('#yourAppElement');"
    >
      <h2 className="modalTitle" ref={(_subtitle) => (subtitle = _subtitle)}>
        Viewing Adjustment Employees
      </h2>
      <div className="modalBody" style={{ maxHeight: "300px", overflowY: "scroll", border: "1px solid #DDF" }}>
        {adjustmentEmployeeList.map((employeeItem, index)=>{
          const rowColor = index % 2 !== 0 ? "rgb(255,255,255)" : "rgb(245,245,255)";
          return <div key={Utils.guid()} style={{ backgroundColor:rowColor }}>
            <span>{Utils.decodeHTML(employeeItem.last_name)}, {Utils.decodeHTML(employeeItem.first_name)}</span>
          </div>
        })}
      </div>
      <div className="modalFooter">
        <button className="btn btn-primary" onClick={closeEmployeeListModal}>Close</button>
      </div>
    </Modal> 
       
    <Modal
      isOpen={modalCompensationIsOpen}
      onAfterOpen={afterOpenCompensationModal}
      onRequestClose={closeCompensationModal}
      style={requestCompensationModalStyles}
      contentLabel="Request Adjustments"
      ariaHideApp={false} // ignores need for "Modal.setAppElement('#yourAppElement');"
    >
      <h2 className="modalTitle" ref={(_subtitle) => (subtitle = _subtitle)}>
        Open Compensation
      </h2>
      <div className="modalBody">
        Opening Date: 
        <Datetime 
            dateFormat="MM-DD-YYYY" 
            timeFormat={false}
            closeOnSelect={true} 
            onChange={e => {
              // console.log(e, e.format("MM-DD-YYYY"));
              setCompensationOpenDate(e.format("MM-DD-YYYY"))
            }} 
        /><br />
        Eligibility Date: 
        <Datetime 
            dateFormat="MM-DD-YYYY" 
            timeFormat={false}
            closeOnSelect={true} 
            onChange={e => {
              // console.log(e, e.format("MM-DD-YYYY"));
              setCompensationEligibilityDate(e.format("MM-DD-YYYY"))
            }} 
        /><br />        
        Effective Date: 
        <Datetime 
            dateFormat="MM-DD-YYYY" 
            timeFormat={false}
            closeOnSelect={true} 
            onChange={e => {
              // console.log(e, e.format("MM-DD-YYYY"));
              setCompensationEffectiveDate(e.format("MM-DD-YYYY"))
            }} 
        /><br />
        Deadline Date: 
        <Datetime 
            dateFormat="MM-DD-YYYY" 
            timeFormat={false}
            closeOnSelect={true} 
            onChange={e => {
              setCompensationDeadlineDate(e.format("MM-DD-YYYY"))
            }} 
        /><br />
        WA FLSA Threshold: 
        <input 
          type='number' 
          step='0.01'
          placeholder='e.g. 75000'
          value={waFlsaThreshold}
          onChange={e => {
            setWaFlsaThreshold(e.target.value)
          }} 
        />
        <br />
        Override current open adjustments: 
        <input 
          type='checkbox' 
          checked={overrideCurrentAdjustments}
          id='overrideCurrentAdjustments' 
          name='overrideCurrentAdjustments' 
          onChange={e => {
            setOverrideCurrentAdjustments(e.target.checked)
          }} /><br />
      </div>
      <div className="modalFooter">
        <button className="btn btn-primary" onClick={()=>{

          requestCompensations();

        }}>OK</button>
        <button className="btn btn-primary" onClick={closeCompensationModal}>Cancel</button>
      </div>
    </Modal> 

    <Modal
      isOpen={modalRequestResultsIsOpen}
      onAfterOpen={afterOpenRequestResultsModal}
      onRequestClose={closeRequestResultsModal}
      style={modalStyles}
      contentLabel="Request Results"
      ariaHideApp={false} // ignores need for "Modal.setAppElement('#yourAppElement');"
    >
      <h2 className="modalTitle" ref={(_subtitle) => (subtitle = _subtitle)}>
        Employees Excluded from Compensation Request
      </h2>
      <div>
        <span className="hrHeaderPendingRequests wide"><b>Employee Number</b></span>
        <span className="hrHeaderPendingRequests wide"><b>First Name</b></span>
        <span className="hrHeaderPendingRequests wide"><b>Last Name</b></span>
        <span className="hrHeaderPendingRequests"><b>Date of Hire</b></span>
      </div>      
      <div className="modalBody modalRequestResultBody" style={{ border: "1px solid #DDF" }}>
        {
            ineligibleEmployees ? 
            ineligibleEmployees.sort((a,b)=>{
              var textA = a.first_name.toUpperCase();
              var textB = b.first_name.toUpperCase();              
              return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
            }
        ).map((employeeObject, index)=>{
          
          const rowColor = index % 2 !== 0 ? "#FFF" : "#EEF";

          return <div key={Utils.guid()} style={{ backgroundColor:rowColor }}>
            <span className="hrLabelPendingRequests wide">{employeeObject.employee_hris_id}</span>
            <span className="hrLabelPendingRequests wide">{Utils.decodeHTML(employeeObject.first_name)}</span>
            <span className="hrLabelPendingRequests wide">{Utils.decodeHTML(employeeObject.last_name)}</span>
            <span className="hrLabelPendingRequests">{Utils.maskDateAs("mdy", new Date(employeeObject.date_of_hire.substring(0,10) + " 12:00:00"))}</span>
            {requestResultsStatus === "pending" ? 
              <span className="hrLabelPendingRequests">
                <button className="btn btn-primary" style={{margin:"5px"}} onClick={(e)=>{
                  e.preventDefault();
                  if(window.confirm("This will enable this employee to recieve compensation updates.  Are you sure you would like to continue?")){
                    removeExclusion(employeeObject, e);
                  }
                  return false;
                }}>Enable</button>
              </span> 
            : null}
          </div>;
        }) : "No exclusions for this adjustment"}
      </div>
      <div className="modalFooter">
        <button className="btn btn-primary" onClick={()=>{
          closeRequestResultsModal()
        }}>Close</button>

        {requestResultsStatus === "pending" ? 
          <button className="btn btn-primary" style={{float:"right"}} onClick={(e)=>{
            e.preventDefault();
            openAddExclusionModal(e);
            return false;
          }}>Add Exclusion</button>
        : null}
      </div>
    </Modal>


    <Modal
      isOpen={addExclusionIsOpen}
      onAfterOpen={afterOpenAddExclusionModal}
      onRequestClose={closeAddExclusionModal}
      style={addExclusionModalStyles}
      contentLabel="Add Exclusion"
      ariaHideApp={false} // ignores need for "Modal.setAppElement('#yourAppElement');"
    >
      <h2 className="modalTitle" ref={(_subtitle) => (subtitle = _subtitle)}>
        Add Exclusion
      </h2>
      <div className="modalBody">
        <select name='employees_list' value={selectedAddExclusion} onChange={(event)=>{
          event.preventDefault();
          // console.log("event", event);
          setSelectedAddExclusion(event.target.value);
          return false;
        }}>
          <option value="-1">--None Selected</option>
          {selectedAdjustmentDetailsData && selectedAdjustmentDetailsData.employee_list ? selectedAdjustmentDetailsData.employee_list.map((adjustmentEmployee)=>{
            return <option key={Utils.guid()} value={adjustmentEmployee.employee_hris_id}>{Utils.decodeHTML(adjustmentEmployee.first_name)} {Utils.decodeHTML(adjustmentEmployee.last_name)}</option>
          }) : null}
        </select>
      </div>
      <div className="modalFooter">
        <button className="btn btn-primary" onClick={addExclusion}>Add Exclusion</button>
        <button className="btn btn-primary" onClick={closeAddExclusionModal}>Close</button>
      </div>
    </Modal> 

    <Modal
      isOpen={modalEmailIsOpen}
      onAfterOpen={afterOpenEmailModal}
      onRequestClose={closeEmailModal}
      style={modalStyles}
      contentLabel="Send Emails"
      ariaHideApp={false} // ignores need for "Modal.setAppElement('#yourAppElement');"
    >
      <h2 className="modalTitle" ref={(_subtitle) => (subtitle = _subtitle)}>
        Send compensation email to managers
      </h2>
      <div className="modalBody">

        <span style={{ fontWeight:"bold",fontSize:"10pt", fontStyle:"italic" }}>
          Note: Use Ctrl+Click to select and deselect.
        </span><br />
        <select 
          multiple={true} 
          name='managers_list' 
          value={selectedManagers} 
          onChange={(event)=>{
            event.preventDefault();
            handleSelectManager(event, event.target);
            return false;
          }}
          style={{
            width: "300px"
          }}
        >
          {/* <option key={Utils.guid()} value="-1">--All Managers--</option> */}
          {adjustmentManagers ? adjustmentManagers.map((adjustmentManagerItem)=>{
            return <option key={Utils.guid()} value={adjustmentManagerItem.id}>
              {Utils.decodeHTML(adjustmentManagerItem.last_name)}, {Utils.decodeHTML(adjustmentManagerItem.first_name)}
            </option>;
          }) : null}
        </select><br /><br />

        Subject: 
        <TextField 
          type="text" 
          name="emailSubject" 
          id="emailSubject" 
          className="emailSubjectInput" 
          value={emailSubject} 
          fullWidth={true}
          onChange={(event)=>{setEmailSubject(event.target.value);}}
        />

        <Editor
          id="emailContents"
          editorState={editorState}
          wrapperClassName="hr-editor-wrapper"
          editorClassName="hr-editor-input"
          onEditorStateChange={onEditorStateChange}
        />
        
      </div>
      <div className="modalFooter">
        <button className="btn btn-primary" onClick={()=>{
          saveEmailTemplate();
          return false;
        }}>Save Template</button>

        <button className="btn btn-primary" onClick={()=>{
          openPreviewModal();
          return false;
        }}>Preview Email</button>

        &nbsp;&nbsp;&nbsp;
      
        <button className="btn btn-primary" onClick={()=>{
          let confirmationMessage = "This will email the selected managers with a request for compensation updates.  Continue?";
          if(adjustmentStatus==="approved"){
            confirmationMessage = "This will email the selected managers confirming their adjustments are approved.  Continue?"
          }

          if(window.confirm(confirmationMessage)){
            emailManagers();
          }

          return false;
        }}>Send Emails</button>
        
        <button className="btn btn-primary" onClick={closeEmailModal}>Cancel</button>
      
      </div>
    </Modal> 


    <Modal
      isOpen={modalDateIsOpen}
      onAfterOpen={afterOpenDateModal}
      onRequestClose={closeDateModal}
      style={dateModalStyles}
      contentLabel="Change Date"
      ariaHideApp={false} // ignores need for "Modal.setAppElement('#yourAppElement');"
    >
      <h2 className="modalTitle" ref={(_subtitle) => (subtitle = _subtitle)}>
        Set {modalDateType} Date
      </h2>
      <div className="modalBody">
        {modalDateType} Date: {modalDateValue}
        <Datetime 
            value={new Date(modalDateValue + " 12:00:00")}
            dateFormat="MM-DD-YYYY" 
            timeFormat={false}
            closeOnSelect={true} 
            onChange={e => {
              console.log(e);
              let dateValue;
              console.log("typeof dateValue", typeof e);
              if(typeof e !== "string"){
                dateValue = e.format("MM-DD-YYYY");
              }else{
                dateValue = e;
              }
              setModalDateValue(dateValue);
              return false;
            }} 
        />
      </div>
      <div className="modalFooter">
        <button className="btn btn-primary" onClick={()=>{
          const dateValueToCheck = new Date(modalDateValue);

          if(!isNaN(dateValueToCheck.getTime()) && dateValueToCheck instanceof Date && isFinite(dateValueToCheck)){
            Utils.postData(
              "/api/employee_adjustment/set_dates", 
              {
                open_date: modalDateAdjustment.open_date,
                eligibility_date: modalDateAdjustment.eligibility_date,
                effective_date: modalDateAdjustment.effective_date,
                deadline_date: modalDateAdjustment.deadline_date,
                new_date_type : modalDateType,
                new_date_value : modalDateValue
              },
              instance, 
              account
            ).then((data) => {
        
              closeDateModal();
              fetchData();
  
            }).catch((error)=>{
              
              console.log("ERROR", error);
              alert("There was an error creating the requested compensation.");
              
            });
          }else{
            window.alert("The date entered in invalid, please enter a valid date to continue.");
          }
          return false;
        }}>OK</button>
        <button className="btn btn-primary" onClick={closeDateModal}>Cancel</button>
      </div>
    </Modal> 

    <Modal
      isOpen={modalWaFlsaThresholdIsOpen}
      onRequestClose={closeWaFlsaThresholdModal}
      style={dateModalStyles}
      contentLabel="Set WA FLSA Threshold"
      ariaHideApp={false}
    >
      <h2 className="modalTitle" ref={(_subtitle) => (subtitle = _subtitle)}>
        Set WA FLSA Threshold
      </h2>
      <div className="modalBody">
        WA FLSA Threshold: 
        <input 
          type='number' 
          step='0.01'
          placeholder='e.g. 75000'
          value={modalWaFlsaThresholdValue}
          onChange={e => {
            setModalWaFlsaThresholdValue(e.target.value)
          }} 
        />
      </div>
      <div className="modalFooter">
        <button className="btn btn-primary" onClick={()=>{
          const thresholdValue = modalWaFlsaThresholdValue ? parseFloat(modalWaFlsaThresholdValue) : null;

          const effectiveDate = modalWaFlsaThresholdAdjustment.effective_date;
          const effectiveDateParts = effectiveDate.split("-");
          const formattedEffectiveDate = effectiveDateParts[1] + "-" + effectiveDateParts[2] + "-" + effectiveDateParts[0];

          Utils.postData(
            "/api/employee_adjustment/set_wa_flsa_threshold", 
            {
              effective_date: formattedEffectiveDate,
              wa_flsa_threshold: thresholdValue
            },
            instance, 
            account
          ).then((data) => {
      
            closeWaFlsaThresholdModal();
            fetchData();

          }).catch((error)=>{
            
            console.log("ERROR", error);
            alert("There was an error updating the WA FLSA threshold.");
            
          });
          return false;
        }}>OK</button>
        <button className="btn btn-primary" onClick={closeWaFlsaThresholdModal}>Cancel</button>
      </div>
    </Modal>


    <Modal
      isOpen={missingRangesIsOpen}
      onAfterOpen={afterOpenMissingRangesModal}
      onRequestClose={closeMissingRangesModal}
      style={missingRangesModalStyles}
      contentLabel="Missing Salary Ranges"
      ariaHideApp={false}
    >
      <h2 className="modalTitle" ref={(_subtitle) => (subtitle = _subtitle)}>
        Employees Missing Salary Ranges <button className="btn btn-primary" style={{ float:"right" }} onClick={closeMissingRangesModal}>Close</button>
      </h2>
      <div className="modalBody">
        <MaterialReactTable 
          columns={missingRangesColumns} 
          data={missingRangesData}
          globalFilterFn="contains" 
          positionToolbarAlertBanner="bottom"
          muiTableContainerProps={{ sx: { height: "500px" } }}
          enableTopToolbar={true}
          enableSelectAll={false}
          editDisplayMode={'row'}
          enableEditing={true}
          onEditingRowCancel={({ row, values, table }) => {
            return false;
          }}
          onEditingRowSave={async ({ row, values, table }) => {
            const saveResult = await handleSaveSalaryRange(row.original.salary_group_id, values);
            console.log(saveResult);
            if(saveResult !== "Validation Failed"){
              table.setEditingRow(null); //exit editing mode
            }
            return false;
          }}
          state={{
            isLoading: false,
            showAlertBanner: false,
            showProgressBars: false,
            tableData: mailerHistoryData
          }}
          initialState={{
            pagination: { pageSize: 100, pageIndex: 0 } 
          }}
        />
      </div>
    </Modal> 

    
    <Modal
      isOpen={mailerHistoryIsOpen}
      onAfterOpen={afterOpenMailerHistoryModal}
      onRequestClose={closeMailerHistoryModal}
      style={mailerHistoryModalStyles}
      contentLabel="Mailer History"
      ariaHideApp={false} // ignores need for "Modal.setAppElement('#yourAppElement');"
    >
      <h2 className="modalTitle" ref={(_subtitle) => (subtitle = _subtitle)}>
        Email History <button className="btn btn-primary" style={{ float:"right" }} onClick={closeMailerHistoryModal}>Close</button>
      </h2>
      <div className="modalBody">
        
        {
        displayMailerMessage ? 
          <div>
            <div>Subject: {}</div>
            <div dangerouslySetInnerHTML={{ __html : selectedMailerMessage }} /> 
            <a href="#" onClick={()=>{
              setDisplayMailerMessage(false);
              return false;
            }}>Return to messages</a>
          </div> : 
          <MaterialReactTable 
            columns={mailerHistoryColumns} 
            data={mailerHistoryData}
            globalFilterFn="contains" 
            positionToolbarAlertBanner="bottom"
            muiTableContainerProps={{ sx: { height: "500px" } }}
            enableTopToolbar={true}
            enableSelectAll={false}
            state={{
              isLoading: false,
              showAlertBanner: false,
              showProgressBars: false,
              tableData: mailerHistoryData
            }}
          />
        }

      </div>
    </Modal> 


    <Modal
      isOpen={modalPreviewIsOpen}
      onAfterOpen={afterOpenPreviewModal}
      onRequestClose={closePreviewModal}
      style={modalStyles}
      contentLabel="Preview email"
      ariaHideApp={false} // ignores need for "Modal.setAppElement('#yourAppElement');"
    >
      <h2 className="modalTitle" ref={(_subtitle) => (subtitle = _subtitle)}>
        Email Preview
      </h2>
      <div className="modalBody previewEmailBlock">
      
        <Editor 
          toolbarHidden
          editorState={
            EditorState.createWithContent(
              ContentState.createFromBlockArray(
                convertFromHTML(
                  draftToHtml(
                    convertToRaw(
                      editorState.getCurrentContent()
                    )
                  ).replace(/#COMPENSATIONLINK#/g, 
                    sampleUrl+
                    (adjustmentStatus==="approved"?("&effectiveDate="+(activeAdjustment?activeAdjustment.effective_date:"")):"")
                  )
                )
              )
            )
          } 
          readOnly={true} 
        /> 
      </div>
      <div className="modalFooter">
        <button className="btn btn-primary" onClick={closePreviewModal}>Close</button>
      </div>
    </Modal> 


    <div>
      <div className={'bold header'}>Access Controls</div>
      <div className={'bold'}>You are logged in as {accounts ? accounts[0].username : "UNKNOWN"}</div>
      <div>&nbsp;</div>
      <div>
        <div key={Utils.guid()} className={'bold'}>Users List</div>
        <div key={Utils.guid()}>&nbsp;</div>
        {userData.map((account)=>{
          return <div key={Utils.guid()}>
            <span onClick={()=>{
              openUserModal("edit", account)
            }} className="iconContainer"><EditIcon /></span>
            <span onClick={()=>{
              openUserModal("delete", account)
            }} className="iconContainer"><DeleteIcon /></span>
            <span className="emailContainer">{account.email} ({account.access_level})</span>
          </div>;
        })}
        <div key={Utils.guid()}>&nbsp;</div>
        <div>
          <button className="btn btn-primary" onClick={()=>{
              openUserModal("add", null)
          }}>Add New Administrator</button>
        </div>
      </div>
      <div>&nbsp;</div>
      <div>&nbsp;</div>
    </div>

    <div className={'bold header'}>Email History</div>
    <div>
      <a className={"emailHistoryLink"} style={{cursor:"pointer"}} onClick={(e)=>{
        e.preventDefault();
        openMailerHistoryModal();
        return false;
      }}>Show email history</a>
      <br />
      <br />
    </div>

    <div className={'bold header'}>Missing Salary Groups</div>
    <div>
      <a className={"emailHistoryLink"} style={{cursor:"pointer"}} onClick={(e)=>{
        e.preventDefault();
        openMissingRangesModal();
        return false;
      }}>Show employees missing ranges for {(new Date()).getFullYear()}</a> - {missingRangesData.length ? missingRangesData.length : 0} missing ranges found for {(new Date()).getFullYear()}.
      <br />
      <br />    
    </div>

    <div className={'bold header'}>Adjustments</div>
    <div>
      <a href={'/compensation?managerHrisId='+employeeHrisId}>Show my open adjustments</a><br /><br />
      <a href='/compensation'>Show *all* open adjustments</a>
      <br />
      <br />
      {pendingAdjustmentsData && pendingAdjustmentsData.length ? (<div className="hrAdjustmentsTable">
        <strong>Non-Submitted Compensation Adjustments:</strong>
        {pendingAdjustmentsData.map((pendingAdjustmentItem)=>{
          return <div className="hrAdjustmentRow" key={Utils.guid()}>
            <span className='hrViewPendingRequests'><a href={
              '/adjustments?status=pending&effective_date=' + pendingAdjustmentItem.effective_date + 
                '&eligibility_date=' + (pendingAdjustmentItem.eligibility_date ? pendingAdjustmentItem.eligibility_date : "") + 
                '&open_date=' + (pendingAdjustmentItem.open_date ? pendingAdjustmentItem.open_date : "") + 
                '&deadline_date=' + (pendingAdjustmentItem.deadline_date ? pendingAdjustmentItem.deadline_date : "")
            }>View</a></span>
            <span className='hrViewPendingRequests wide'><a href="#" onClick={(event)=>{
              event.preventDefault();

              Utils.getData(
                ('/api/compensation/managers?status=pending&effective_date='+pendingAdjustmentItem.effective_date + 
                '&eligibility_date=' + (pendingAdjustmentItem.eligibility_date ? pendingAdjustmentItem.eligibility_date : "") + 
                '&open_date=' + (pendingAdjustmentItem.open_date ? pendingAdjustmentItem.open_date : "") + 
                '&deadline_date=' + (pendingAdjustmentItem.deadline_date ? pendingAdjustmentItem.deadline_date : "")), 
                instance, 
                account
              ).then((adjustmentManagesResult)=>{

                Utils.getData(
                  ('/api/email_template?status=pending'), 
                  instance, 
                  account
                ).then((emailTemplatesResult)=>{

                  let filteredManagers = [];
                  let invalidManagers = [];
                  for(var i=0;i<adjustmentManagesResult.length;i++){
                    if(adjustmentManagesResult[i].email){
                      filteredManagers.push(adjustmentManagesResult[i]);
                    }else{
                      invalidManagers.push(adjustmentManagesResult[i].first_name + " " + adjustmentManagesResult[i].last_name);
                    }
                  }

                  let managerMessage = "The following managers are no longer valid.  Please review they are still members of the GeoEngineers Inc. team: " + invalidManagers.join("\n") + "\nPress OK to continue without these users.";

                  if(invalidManagers.length && window.confirm(managerMessage)){
                    openEmailModal(pendingAdjustmentItem, filteredManagers, "pending", emailTemplatesResult[0]);
                  }else{
                    openEmailModal(pendingAdjustmentItem, filteredManagers, "pending", emailTemplatesResult[0]);
                  }

                });

              });
              
              return false;
            }}>Email Managers</a></span>            
            <span className='hrLabelDateRequests'>
              <span>
                Opening Date: <a href="#" onClick={()=>{
                  openDateModal(pendingAdjustmentItem, "Open", "pending");
                  return false;
                }}>{pendingAdjustmentItem.open_date ? Utils.maskDateAs("mdy", new Date(pendingAdjustmentItem.open_date + " 12:00:00")) : "No date set"}</a>
              </span>

              <span>
                Eligibility Date:&nbsp;
                {/* <a href="#" onClick={()=>{
                  openDateModal(pendingAdjustmentItem, "Eligibility", "pending");
                  return false;
                }}>{pendingAdjustmentItem.eligibility_date ? Utils.maskDateAs("mdy", new Date(pendingAdjustmentItem.eligibility_date + " 12:00:00")) : "No date set"}</a> */}
                {pendingAdjustmentItem.eligibility_date ? Utils.maskDateAs("mdy", new Date(pendingAdjustmentItem.eligibility_date + " 12:00:00")) : "No date set"}
              </span>

              <span>
                Effective Date:  <a href="#" onClick={()=>{
                  openDateModal(pendingAdjustmentItem, "Effective", "pending");
                  return false;
                }}>{Utils.maskDateAs("mdy", new Date(pendingAdjustmentItem.effective_date + " 12:00:00"))}</a>
              </span>

              <span>
                Deadline Date:  <a href="#" onClick={()=>{
                  openDateModal(pendingAdjustmentItem, "Deadline", "pending");
                  return false;
                }}>{pendingAdjustmentItem.deadline_date ? Utils.maskDateAs("mdy", new Date(pendingAdjustmentItem.deadline_date + " 12:00:00")) : "No Deadline"}</a>
              </span>

              <span>
                WA FLSA Threshold:  <a href="#" onClick={(event)=>{
                  event.preventDefault();
                  openWaFlsaThresholdModal(pendingAdjustmentItem);
                  return false;
                }}>{pendingAdjustmentItem.wa_flsa_threshold !== null && pendingAdjustmentItem.wa_flsa_threshold !== undefined ? ("$" + Number(pendingAdjustmentItem.wa_flsa_threshold).toLocaleString()) : "Not set"}</a>
              </span>

            </span>
            <span className='hrLabelUuidRequests'>
              <a href="#" onClick={(event)=>{
                event.preventDefault();

                Utils.getData(
                  ('/api/employee_adjustment?status=pending&effective_date=' + pendingAdjustmentItem.effective_date + 
                  '&eligibility_date=' + (pendingAdjustmentItem.eligibility_date ? pendingAdjustmentItem.eligibility_date : "") + 
                  '&open_date=' + (pendingAdjustmentItem.open_date ? pendingAdjustmentItem.open_date : "") + 
                  '&deadline_date=' + (pendingAdjustmentItem.deadline_date ? pendingAdjustmentItem.deadline_date : "")), 
                  instance, 
                  account
                ).then((jsonEmployeeList)=>{
                  setAdjustmentEmployeeList(jsonEmployeeList);
                  openEmployeeListModal();
                });

                return false;
              }}>Employees</a>&nbsp;
            </span>
            <span className='hrLabelEmployeesRequests'>Total Employees: {pendingAdjustmentItem.num_employees}</span>
            <span className='hrViewPendingRequests'>
              <a href="#" onClick={(event)=>{
                event.preventDefault();

                Utils.getData(
                  ('/api/employee_adjustment/details?status=pending&effective_date=' + pendingAdjustmentItem.effective_date), 
                  instance, 
                  account
                ).then((jsonAdjustmentLogResponse)=>{
                  //get logged exclusions
                  const processEmployees = processIneligibleEmployees(jsonAdjustmentLogResponse);
                  jsonAdjustmentLogResponse[0].employee_list.sort((a,b)=>{ 
                    if(a.first_name < b.first_name){ return -1; }
                    if(a.first_name > b.first_name){ return 1; }
                    return 0
                  });
                  setSelectedAdjustmentDetailsData(jsonAdjustmentLogResponse[0]);
                  setRequestResultsStatus("pending");
                  setIneligibleEmployees(processEmployees);
                  openRequestResultsModal();
                });

                return false;
              }}>Exclusions</a>&nbsp;
            </span>
            <span className='hrViewPendingRequests'><a href="#" onClick={(event)=>{
              event.preventDefault();
              if(window.confirm("WARNING: This is archive/close all compensation adjustments connected to this request.")){
                closeAdjustmentByDateAndStatus(pendingAdjustmentItem.effective_date, "pending");
              }
              return false;
            }}>Close</a></span>             
            <span className='hrViewPendingRequests'><a href="#" onClick={(event)=>{
              event.preventDefault();
              if(window.confirm("WARNING: This is remove all compensation adjustments connected to this request.")){
                deleteAdjustmentByDateAndStatus(pendingAdjustmentItem.effective_date, "pending");
              }
              return false;
            }}>Delete</a></span>             
          </div>;
        })}
        <div>&nbsp;</div>
      </div>) : null}
    </div>

    <div>
      {reviewAdjustmentsData && reviewAdjustmentsData.length ? (<div className="hrAdjustmentsTable">
        <strong>Submitted/Non-Approved Compensation Adjustments:</strong>
        {reviewAdjustmentsData.map((reviewAdjustmentItem)=>{
          return <div className="hrAdjustmentRow" key={Utils.guid()}>
            <span className='hrViewPendingRequests'><a href={
              '/adjustments?status=review&effective_date=' + reviewAdjustmentItem.effective_date + 
                '&eligibility_date=' + (reviewAdjustmentItem.eligibility_date ? reviewAdjustmentItem.eligibility_date : "") + 
                '&open_date=' + (reviewAdjustmentItem.open_date ? reviewAdjustmentItem.open_date : "") + 
                '&deadline_date=' + (reviewAdjustmentItem.deadline_date ? reviewAdjustmentItem.deadline_date : "")
            }>View</a></span>
            <span className='hrViewPendingRequests wide'><a href="#" onClick={(event)=>{
              event.preventDefault();

              Utils.getData(
                ('/api/compensation/managers?status=review&effective_date='+reviewAdjustmentItem.effective_date + 
                '&eligibility_date=' + (reviewAdjustmentItem.eligibility_date ? reviewAdjustmentItem.eligibility_date : "") + 
                '&open_date=' + (reviewAdjustmentItem.open_date ? reviewAdjustmentItem.open_date : "") + 
                '&deadline_date=' + (reviewAdjustmentItem.deadline_date ? reviewAdjustmentItem.deadline_date : "")), 
                instance, 
                account
              ).then((adjustmentManagers)=>{
                
                Utils.getData(
                  ('/api/email_template?status=review'), 
                  instance, 
                  account
                ).then((emailTemplatesResult)=>{

                  let filteredManagers = [];
                  let invalidManagers = [];
                  for(var i=0;i<adjustmentManagers.length;i++){
                    if(adjustmentManagers[i].email){
                      filteredManagers.push(adjustmentManagers[i]);
                    }else{
                      invalidManagers.push(adjustmentManagers[i].first_name + " " + adjustmentManagers[i].last_name);
                    }
                  }

                  let managerMessage = "The following managers are no longer valid.  Please review they are still members of the GeoEngineers Inc. team: " + invalidManagers.join("\n") + "\nPress OK to continue without these users.";

                  if(invalidManagers.length && window.confirm(managerMessage)){
                    openEmailModal(reviewAdjustmentItem, adjustmentManagers, "review", emailTemplatesResult[0]);
                  }else{
                    openEmailModal(reviewAdjustmentItem, adjustmentManagers, "review", emailTemplatesResult[0]);
                  }

                });

              });
              
              return false;
            }}>Email Managers</a></span>            
            <span className='hrLabelDateRequests'>
              <span>Opening Date: {reviewAdjustmentItem.open_date ? Utils.maskDateAs("mdy", new Date(reviewAdjustmentItem.open_date + " 12:00:00")) : "No date set"}</span>
              <span>Eligibility Date: {reviewAdjustmentItem.eligibility_date ? Utils.maskDateAs("mdy", new Date(reviewAdjustmentItem.eligibility_date + " 12:00:00")) : "No date set"}</span>
              <span>Effective Date: {Utils.maskDateAs("mdy", new Date(reviewAdjustmentItem.effective_date + " 12:00:00"))}</span>
              <span>Deadline Date: {reviewAdjustmentItem.deadline_date ? Utils.maskDateAs("mdy", new Date(reviewAdjustmentItem.deadline_date + " 12:00:00")) : "No Deadline"} </span>
              <span>WA FLSA Threshold: <a href="#" onClick={(event)=>{
                  event.preventDefault();
                  openWaFlsaThresholdModal(reviewAdjustmentItem);
                  return false;
                }}>{reviewAdjustmentItem.wa_flsa_threshold !== null && reviewAdjustmentItem.wa_flsa_threshold !== undefined ? ("$" + Number(reviewAdjustmentItem.wa_flsa_threshold).toLocaleString()) : "Not set"}</a>
              </span>
            </span>
            <span className='hrLabelUuidRequests'>
              <a href="#" onClick={(event)=>{
                event.preventDefault();

                Utils.getData(
                  ('/api/employee_adjustment?status=review&effective_date=' + reviewAdjustmentItem.effective_date + 
                  '&eligibility_date=' + (reviewAdjustmentItem.eligibility_date ? reviewAdjustmentItem.eligibility_date : "") + 
                  '&open_date=' + (reviewAdjustmentItem.open_date ? reviewAdjustmentItem.open_date : "") + 
                  '&deadline_date=' + (reviewAdjustmentItem.deadline_date ? reviewAdjustmentItem.deadline_date : "")), 
                  instance, 
                  account
                ).then((jsonEmployeeList)=>{
                  setAdjustmentEmployeeList(jsonEmployeeList);
                  openEmployeeListModal();
                });

                return false;
              }}>Employees</a>&nbsp;
            </span>
            <span className='hrLabelEmployeesRequests'>Total Employees: {reviewAdjustmentItem.num_employees}</span>
            <span className='hrViewPendingRequests'>
              <a href="#" onClick={(event)=>{
                event.preventDefault();

                Utils.getData(
                  ('/api/employee_adjustment/details?status=review&effective_date=' + reviewAdjustmentItem.effective_date), 
                  instance, 
                  account
                ).then((jsonAdjustmentLogResponse)=>{
                  //get logged exclusions
                  const processEmployees = processIneligibleEmployees(jsonAdjustmentLogResponse);
                  setSelectedAdjustmentDetailsData(jsonAdjustmentLogResponse[0]);
                  setRequestResultsStatus("review");
                  setIneligibleEmployees(processEmployees);
                  openRequestResultsModal();
                });

                return false;
              }}>Exclusions</a>&nbsp;
            </span>
            <span className='hrViewPendingRequests'><a href="#" onClick={(event)=>{
              event.preventDefault();
              if(window.confirm("WARNING: This is archive/close all compensation adjustments connected to this request.")){
                closeAdjustmentByDateAndStatus(reviewAdjustmentItem.effective_date, "review");
              }
              return false;
            }}>Close</a></span>
            <span className='hrViewPendingRequests'><a href="#" onClick={(event)=>{
              event.preventDefault();
              if(window.confirm("WARNING: This is remove all compensation adjustments connected to this request.")){
                deleteAdjustmentByDateAndStatus(reviewAdjustmentItem.effective_date, "review");
              }
              return false;
            }}>Delete</a></span>                
          </div>;
        })}
        <div>&nbsp;</div>
      </div>) : null}
    </div>

    <div>
      {approvedAdjustmentsData && approvedAdjustmentsData.length ? (<div className="hrAdjustmentsTable">
        <strong>Approved Compensation Adjustments: </strong>
        {approvedAdjustmentsData.map((approvedAdjustmentItem)=>{
          return <div className="hrAdjustmentRow" key={Utils.guid()}>
            <span className='hrViewPendingRequests'><a href={
              '/adjustments?status=approved&effective_date=' + approvedAdjustmentItem.effective_date + 
              '&eligibility_date=' + (approvedAdjustmentItem.eligibility_date ? approvedAdjustmentItem.eligibility_date : "") + 
                '&open_date=' + (approvedAdjustmentItem.open_date ? approvedAdjustmentItem.open_date : "") + 
                '&deadline_date=' + (approvedAdjustmentItem.deadline_date ? approvedAdjustmentItem.deadline_date : "")
            }>View</a></span>
            <span className='hrViewPendingRequests wide'><a href="#" onClick={(event)=>{
              event.preventDefault();

              Utils.getData(
                ('/api/compensation/managers?status=approved&effective_date='+approvedAdjustmentItem.effective_date + 
                '&eligibility_date=' + (approvedAdjustmentItem.eligibility_date ? approvedAdjustmentItem.eligibility_date : "") + 
                '&open_date=' + (approvedAdjustmentItem.open_date ? approvedAdjustmentItem.open_date : "") + 
                '&deadline_date=' + (approvedAdjustmentItem.deadline_date ? approvedAdjustmentItem.deadline_date : "")), 
                instance, 
                account
              ).then((adjustmentManagers)=>{

                Utils.getData(
                  ('/api/email_template?status=approved'), 
                  instance, 
                  account
                ).then((emailTemplatesResult)=>{

                  let filteredManagers = [];
                  let invalidManagers = [];
                  for(var i=0;i<adjustmentManagers.length;i++){
                    if(adjustmentManagers[i].email){
                      filteredManagers.push(adjustmentManagers[i]);
                    }else{
                      invalidManagers.push(adjustmentManagers[i].first_name + " " + adjustmentManagers[i].last_name);
                    }
                  }

                  let managerMessage = "The following managers are no longer valid.  Please review they are still members of the GeoEngineers Inc. team: " + invalidManagers.join("\n") + "\nPress OK to continue without these users.";

                  if(invalidManagers.length && window.confirm(managerMessage)){
                    openEmailModal(approvedAdjustmentItem, adjustmentManagers, "approved", emailTemplatesResult[0]);
                  }else{
                    openEmailModal(approvedAdjustmentItem, adjustmentManagers, "approved", emailTemplatesResult[0]);
                  }
                });

              });
              
              return false;
            }}>Email Managers</a></span>            
            <span className='hrLabelDateRequests'>
              <span>Opening Date: {approvedAdjustmentItem.open_date ? Utils.maskDateAs("mdy", new Date(approvedAdjustmentItem.open_date + " 12:00:00")) : "No date set"}</span>
              <span>Eligibility Date: {approvedAdjustmentItem.eligibility_date ? Utils.maskDateAs("mdy", new Date(approvedAdjustmentItem.eligibility_date + " 12:00:00")) : "No date set"}</span>
              <span>Effective Date: {Utils.maskDateAs("mdy", new Date(approvedAdjustmentItem.effective_date + " 12:00:00"))}</span>
              <span>Deadline Date: {approvedAdjustmentItem.deadline_date ? Utils.maskDateAs("mdy", new Date(approvedAdjustmentItem.deadline_date + " 12:00:00")) : "No Deadline"}</span>
              <span>WA FLSA Threshold: <a href="#" onClick={(event)=>{
                  event.preventDefault();
                  openWaFlsaThresholdModal(approvedAdjustmentItem);
                  return false;
                }}>{approvedAdjustmentItem.wa_flsa_threshold !== null && approvedAdjustmentItem.wa_flsa_threshold !== undefined ? ("$" + Number(approvedAdjustmentItem.wa_flsa_threshold).toLocaleString()) : "Not set"}</a>
              </span>
            </span>
            <span className='hrLabelPendingRequests'>
              <a href="#" onClick={(event)=>{
                event.preventDefault();

                Utils.getData(
                  ('/api/employee_adjustment?status=approved&effective_date=' + approvedAdjustmentItem.effective_date + 
                  '&eligibility_date=' + (approvedAdjustmentItem.eligibility_date ? approvedAdjustmentItem.eligibility_date : "") + 
                  '&open_date=' + (approvedAdjustmentItem.open_date ? approvedAdjustmentItem.open_date : "") + 
                  '&deadline_date=' + (approvedAdjustmentItem.deadline_date ? approvedAdjustmentItem.deadline_date : "")), 
                  instance, 
                  account
                ).then((jsonEmployeeList)=>{
                  setAdjustmentEmployeeList(jsonEmployeeList);
                  openEmployeeListModal();
                });

                return false;
              }}>Employees</a>&nbsp;              
            </span>
            <span className='hrLabelEmployeesRequests'>Total Employees: {approvedAdjustmentItem.num_employees}</span>
            <span className='hrViewPendingRequests'><a href="#" onClick={(event)=>{
              event.preventDefault();

              Utils.getData(
                ('/api/employee_adjustment/details?status=approved&effective_date=' + approvedAdjustmentItem.effective_date), 
                instance, 
                account
              ).then((jsonAdjustmentLogResponse)=>{
                //get logged exclusions
                const processEmployees = processIneligibleEmployees(jsonAdjustmentLogResponse);
                setSelectedAdjustmentDetailsData(jsonAdjustmentLogResponse[0]);
                setRequestResultsStatus("approved");
                setIneligibleEmployees(processEmployees);
                openRequestResultsModal();
              });

              return false;
            }}>Exclusions</a>&nbsp;</span>   
            
            {activeUser.access_level === "ADMIN" ? <span className='hrViewPendingRequests'><a href="#" onClick={(event)=>{
              event.preventDefault();
              if(window.confirm("WARNING: This is archive/close all compensation adjustments connected to this request.")){
                closeAdjustmentByDateAndStatus(approvedAdjustmentItem.effective_date, "approved");
              }
              return false;
            }}>Close</a></span> : null}
            <span className='hrViewPendingRequests'><a href="#" onClick={(event)=>{
              event.preventDefault();
              if(window.confirm("WARNING: This is remove all compensation adjustments connected to this request.")){
                deleteAdjustmentByDateAndStatus(approvedAdjustmentItem.effective_date, "approved");
              }
              return false;
            }}>Delete</a></span> 
          </div>;
        })}
        <div>&nbsp;</div>
      </div>) : null} 
    </div>

    <div>
      {closedAdjustmentsData && closedAdjustmentsData.length ? (<div className="hrAdjustmentsTable">
        <strong>Closed/Finalized Compensation Adjustments:</strong>
        {closedAdjustmentsData.map((closedAdjustmentItem)=>{
          // console.log("closedAdjustmentItem", closedAdjustmentItem);
          return <div className="hrAdjustmentRow" key={Utils.guid()}>
            <span className='hrViewPendingRequests'><a href={
              '/adjustments?status=closed&effective_date=' + closedAdjustmentItem.effective_date + 
                '&eligibility_date=' + (closedAdjustmentItem.eligibility_date ? closedAdjustmentItem.eligibility_date : "") + 
                '&open_date=' + (closedAdjustmentItem.open_date ? closedAdjustmentItem.open_date : "") + 
                '&deadline_date=' + (closedAdjustmentItem.deadline_date ? closedAdjustmentItem.deadline_date : "")
            }>View</a></span>
            <span className='hrViewPendingRequests wide'><a href="#" onClick={(event)=>{
              event.preventDefault();

              Utils.getData(
                ('/api/compensation/managers?status=closed&effective_date='+closedAdjustmentItem.effective_date + 
                '&eligibility_date=' + (closedAdjustmentItem.eligibility_date ? closedAdjustmentItem.eligibility_date : "") + 
                '&open_date=' + (closedAdjustmentItem.open_date ? closedAdjustmentItem.open_date : "") + 
                '&deadline_date=' + (closedAdjustmentItem.deadline_date ? closedAdjustmentItem.deadline_date : "")), 
                instance, 
                account
              ).then((adjustmentManagers)=>{

                Utils.getData(
                  ('/api/email_template?status=closed'), 
                  instance, 
                  account
                ).then((emailTemplatesResult)=>{

                  let filteredManagers = [];
                  let invalidManagers = [];
                  for(var i=0;i<adjustmentManagers.length;i++){
                    if(adjustmentManagers[i].email){
                      filteredManagers.push(adjustmentManagers[i]);
                    }else{
                      invalidManagers.push(adjustmentManagers[i].first_name + " " + adjustmentManagers[i].last_name);
                    }
                  }

                  let managerMessage = "The following managers are no longer valid.  Please review they are still members of the GeoEngineers Inc. team: " + invalidManagers.join("\n") + "\nPress OK to continue without these users.";

                  if(invalidManagers.length && window.confirm(managerMessage)){
                    openEmailModal(closedAdjustmentItem, adjustmentManagers, "closed", emailTemplatesResult[0]);
                  }else{
                    openEmailModal(closedAdjustmentItem, adjustmentManagers, "closed", emailTemplatesResult[0]);
                  }
                });

              });
              
              return false;
            }}>Email Managers</a></span>            
            <span className='hrLabelDateRequests'>
              <span>Opening Date: {closedAdjustmentItem.open_date ? Utils.maskDateAs("mdy", new Date(closedAdjustmentItem.open_date + " 12:00:00")) : "No date set"}</span>
              <span>Eligibility Date: {closedAdjustmentItem.eligibility_date ? Utils.maskDateAs("mdy", new Date(closedAdjustmentItem.eligibility_date + " 12:00:00")) : "No date set"}</span>
              <span>Effective Date: {Utils.maskDateAs("mdy", new Date(closedAdjustmentItem.effective_date + " 12:00:00"))}</span>
              <span>Deadline Date: {closedAdjustmentItem.deadline_date ? Utils.maskDateAs("mdy", new Date(closedAdjustmentItem.deadline_date + " 12:00:00")) : "No Deadline"}</span>
              <span>WA FLSA Threshold: <a href="#" onClick={(event)=>{
                  event.preventDefault();
                  openWaFlsaThresholdModal(closedAdjustmentItem);
                  return false;
                }}>{closedAdjustmentItem.wa_flsa_threshold !== null && closedAdjustmentItem.wa_flsa_threshold !== undefined ? ("$" + Number(closedAdjustmentItem.wa_flsa_threshold).toLocaleString()) : "Not set"}</a>
              </span>
            </span>
            <span className='hrLabelUuidRequests'>
              <a href="#" onClick={(event)=>{
                event.preventDefault();

                Utils.getData(
                  ('/api/employee_adjustment?status=closed&effective_date=' + closedAdjustmentItem.effective_date + 
                  '&eligibility_date=' + (closedAdjustmentItem.eligibility_date ? closedAdjustmentItem.eligibility_date : "") + 
                  '&open_date=' + (closedAdjustmentItem.open_date ? closedAdjustmentItem.open_date : "") + 
                  '&deadline_date=' + (closedAdjustmentItem.deadline_date ? closedAdjustmentItem.deadline_date : "")), 
                  instance, 
                  account
                ).then((jsonEmployeeList)=>{
                  setAdjustmentEmployeeList(jsonEmployeeList);
                  openEmployeeListModal();
                });

                return false;
              }}>Employees</a>&nbsp;              
            </span>
            <span className='hrLabelEmployeesRequests'>Total Employees: {closedAdjustmentItem.num_employees}</span>
            <span className='hrViewPendingRequests'><a href="#" onClick={(event)=>{
              event.preventDefault();

              Utils.getData(
                ('/api/employee_adjustment/details?status=closed&effective_date=' + closedAdjustmentItem.effective_date), 
                instance, 
                account
              ).then((jsonAdjustmentLogResponse)=>{
                //get logged exclusions
                const processEmployees = processIneligibleEmployees(jsonAdjustmentLogResponse);
                setSelectedAdjustmentDetailsData(jsonAdjustmentLogResponse[0]);
                setRequestResultsStatus("closed");
                setIneligibleEmployees(processEmployees);
                openRequestResultsModal();
              });

              return false;
            }}>Exclusions</a>&nbsp;</span>
          </div>;
        })}
        <div>&nbsp;</div>
      </div>) : null} 
    </div>

    <div>
      
      <button className="btn btn-primary" onClick={()=>{
        const year = (new Date()).getFullYear();

          openCompensationModal();

      }}>Create Compensation Requests For All Employees</button>
    </div>
    <div>&nbsp;</div>
    {/* <div>
      <button className="btn btn-primary" onClick={()=>{
        if(window.confirm("Warning: This will reset all manager approvals!")){
          Utils.deleteData(
            "/api/employee/mananger_approvals", 
            instance, 
            account
          ).then((data) => {
            alert("Approvals have been reset.");
          });  
        }
      }}>Reset all manager approvals</button>
    </div> */}
  </div>) : (<div>Unavailable</div>);
};

export default HR;